import { motion } from "framer-motion";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { BANK, aud } from "@/lib/catalog";

const copy = (v) => {
  navigator.clipboard?.writeText(v).then(() => toast.success("Copied"), () => toast.error("Couldn't copy"));
};

const Row = ({ label, value, id }) => (
  <div className="flex items-center justify-between gap-3 border-b border-[#112E23]/10 py-3">
    <span className="text-sm text-[#112E23]/75">{label}</span>
    <span className="flex items-center gap-2 font-mono text-sm font-semibold text-[#112E23]">
      <span data-testid={`bank-${id}-value`}>{value}</span>
      {id && (
        <button data-testid={`copy-${id}-button`} aria-label={`Copy ${label}`} onClick={() => copy(value)} className="rounded-full p-1.5 transition-colors hover:bg-[#112E23]/10">
          <Copy className="h-3.5 w-3.5" />
        </button>
      )}
    </span>
  </div>
);

export const OrderConfirmation = ({ order }) => (
  <div data-testid="bank-details-modal-container">
    <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 200, damping: 12 }} className="mb-6 grid h-14 w-14 place-items-center rounded-full bg-[#D99B26]">
      <Check className="h-7 w-7 text-[#0F1412]" />
    </motion.div>
    <DialogTitle className="font-display text-4xl font-black uppercase leading-none text-[#112E23] sm:text-5xl">Order placed</DialogTitle>
    <DialogDescription className="mt-3 text-[#112E23]/80">
      Thanks {order?.customer?.name?.split(" ")[0] ?? ""}! Please pay by bank transfer using your order reference. We'll post your balls once payment arrives.
    </DialogDescription>
    <div className="mt-6 rounded-2xl bg-white p-5">
      <Row label="Order reference" value={order?.ref ?? ""} id="reference" />
      <Row label="Amount to pay" value={aud(order?.total)} id="amount" />
      <Row label="Account name" value={BANK.accountName} />
      <Row label="Bank" value={BANK.bank} />
      <Row label="BSB" value={BANK.bsb} id="bsb" />
      <Row label="Account number" value={BANK.account} id="account" />
    </div>
    <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-[#6E472B]">
      {order?.ball_count ?? 0} balls · postage {aud(order?.postage)} · {order?.customer?.state}
    </p>
  </div>
);
